import { createSelector } from 'reselect';
import { subselect } from './root';
import { channelListSelector } from './channelList';

const defaultFilter = ({ logo, background: { normal, grayscale } = {} }) => [
  logo,
  normal,
  grayscale,
];

const imagesSelector = createSelector(
  [channelListSelector],
  (channels) => (imagesFilter = defaultFilter) =>
    channels.length
      ? channels.reduce((images, item) => [...images, ...imagesFilter(item)], [])
      : [],
);

export const linearChannelsImagesSelector = subselect(imagesSelector);
